import {Button, DatePicker, Form, Input, Select, Space} from "antd";
import {useTranslation} from "react-i18next";
import {useDataGrid} from "../../../core/components/data-grid/DataGridContext";
import {useRef, useState} from "react";
import {DATE_OPTIONS, getBeginStr, getDateFromNow, getEndStr} from "../../../core/utils/date-utils";
import HospitalSelectBox from "../../hospital/HospitalSelectBox";
import ModalitySelectBox from "../../modality/ModalitySelectBox";
import KosStatusEnum from "../../../enums/KosStatusEnum";
import {parseListInput} from "../../../core/utils/parse-list-input";

export default function TeletipFilter()
{
    const {t} = useTranslation();
    const {onFilterPageSort} = useDataGrid();
    const formRef = useRef();

    const getDefaultDate = () => {
        const date = getDateFromNow(DATE_OPTIONS.TODAY);
        return [date.start, date.end]
    }

    const date = getDefaultDate();

    const reset = () => {
        window.location.reload()
    }

    const filter = (form) => {
        onFilterPageSort({
            filter: {
                ...form,
                studyReceivedDateTimeBegin: getBeginStr(form.studyReceivedDateTimeBegin),
                studyReceivedDateTimeEnd: getEndStr(form.studyReceivedDateTimeEnd),
                studyIdList: parseListInput(form.studyIdList),
                patientIdList: parseListInput(form.patientIdList),
                accessionNumberList: parseListInput(form.accessionNumberList),
            }
        })
    }

    return (
        <>
            <Form
                ref={formRef}
                onFinish={filter}
                layout={'vertical'}
                initialValues={{
                    studyReceivedDateTimeBegin: date[0],
                    studyReceivedDateTimeEnd: date[1],
                    statusList: []
                }}
            >
                <Space style={{marginBottom: 16}}>
                    <Button type={'primary'} size={'small'} htmlType="submit" >{t('Search')}</Button>
                    <Button size={'small'} onClick={reset}>{t('Reset')}</Button>
                </Space>
                <div
                    style={{display: 'flex', alignItems: 'center'}}
                >
                    <Form.Item
                        label={t('Date')}
                        name="studyReceivedDateTimeBegin"
                    >
                        <DatePicker showToday={false} />
                    </Form.Item>
                    <Form.Item
                        label={' '}
                        name="studyReceivedDateTimeEnd"
                    >
                        <DatePicker showToday={false} />
                    </Form.Item>
                </div>
                <Form.Item
                    label={t('Study Ids')}
                    name={'studyIdList'}
                    extra={t('Separate values with comma, space or new line')}
                >
                    <Input.TextArea rows={3} allowClear placeholder={t('e.g.') + " 10023, 10024 10025"} />
                </Form.Item>
                <Form.Item
                    label={t('Patient Ids')}
                    name={'patientIdList'}
                    extra={t('Separate values with comma, space or new line')}
                >
                    <Input.TextArea rows={3} allowClear placeholder={t('e.g.') + " 12345678901, 98765432109"} />
                </Form.Item>
                <Form.Item
                    label={t('Accession Numbers')}
                    name={'accessionNumberList'}
                    extra={t('Separate values with comma, space or new line')}
                >
                    <Input.TextArea rows={3} allowClear placeholder={t('e.g.') + " 6006169198, 6006169199"} />
                </Form.Item>
                <Form.Item
                    label={t('Patient Name')}
                    name={'patientName'}
                >
                    <Input allowClear />
                </Form.Item>
                <Form.Item
                    label={t('Modality')}
                    name={'modalities'}
                >
                    <ModalitySelectBox />
                </Form.Item>
                <Form.Item
                    label={t('Hospitals')}
                    name="hospitalIdList"
                >
                    <HospitalSelectBox />
                </Form.Item>
                <Form.Item
                    label={t('Status')}
                    name="statusList"
                >
                    <Select
                        mode={'multiple'}
                        options={
                            Object.keys(KosStatusEnum).map(key => ({
                                label: t(`${key}`),
                                value: KosStatusEnum[key]
                            }))
                        }
                    />
                </Form.Item>
            </Form>
        </>
    )
}
